"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPointerPos = function () { return ({
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    x: 0,
    y: 0
}); };
exports.eventToPoint = function (e, point) {
    if (point === void 0) { point = exports.defaultPointerPos(); }
    point.clientX = point.x = e.clientX;
    point.clientY = point.y = e.clientY;
    point.pageX = e.pageX;
    point.pageY = e.pageY;
    return point;
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./~/popmotion/input/pointer/utils.js
// module id = 47
// module chunks = 112359326995148 213534597649335 241203398517478